import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle, ArrowLeft } from "lucide-react";

export default function PagamentoSucesso() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [tx, setTx] = useState(null);
  const [tries, setTries] = useState(0);
  const [failed, setFailed] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (!sessionId) { setFailed(true); return; }
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/public/pagamento/status/${sessionId}`);
        if (!active) return;
        setTx(data);
        if (data.payment_status === "paid" || data.payment_status === "failed" || data.payment_status === "expired") return;
        if (tries >= 20) { setFailed(true); return; }
        timer.current = setTimeout(() => setTries((n) => n + 1), 1500);
      } catch {
        if (!active) return;
        setFailed(true);
      }
    };
    poll();
    return () => { active = false; if (timer.current) clearTimeout(timer.current); };
    // eslint-disable-next-line
  }, [sessionId, tries]);

  const paid = tx?.payment_status === "paid";
  const stillPending = !tx || (tx.payment_status !== "paid" && !failed);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center bg-[#FAFAFA]" data-testid="pagto-sucesso">
      <div className="max-w-md">
        {paid ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-3" />
            <div className="font-heading text-3xl font-bold mb-2">Pagamento confirmado!</div>
            <p className="text-zinc-600 mb-1">
              Valor: <strong>{money(tx?.amount || 0)}</strong> {tx?.parcelas > 1 ? `em ${tx.parcelas}x` : "à vista"}
            </p>
            <p className="text-zinc-500 mb-6 text-sm">Obrigado pela confiança. A BBH foi notificada.</p>
          </>
        ) : failed ? (
          <>
            <XCircle className="w-16 h-16 text-rose-600 mx-auto mb-3" />
            <div className="font-heading text-2xl font-bold mb-2">Não conseguimos confirmar</div>
            <p className="text-zinc-500 mb-6 text-sm">
              Se o pagamento foi concluído, aguarde alguns minutos ou entre em contato com a BBH.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="w-14 h-14 text-[#14243D] mx-auto mb-3 animate-spin" />
            <div className="font-heading text-2xl font-bold mb-2">Confirmando pagamento...</div>
            <p className="text-zinc-500 mb-6 text-sm">Isso leva poucos segundos.</p>
          </>
        )}
        {!stillPending && (
          <Link to="/" data-testid="voltar-home" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bbh-btn-primary text-sm font-semibold">
            <ArrowLeft className="w-4 h-4" /> Voltar ao site
          </Link>
        )}
      </div>
    </div>
  );
}
